/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { BotExamVisualizationOptionViewModel } from "../types/BotExamVisualizationOptionViewModel.ts";

export const botExamVisualizationOptionViewModelSchema = z.object({
  label: z
    .string()
    .describe(
      "Texto da alternativa decodificado (HTML entities convertidas). Opcional.",
    )
    .nullish(),
  isCorrect: z.optional(
    z
      .boolean()
      .describe("Indica se esta alternativa é a resposta correta da questão."),
  ),
}) as unknown as ToZod<BotExamVisualizationOptionViewModel>;
